import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { countries } from 'config/config'; // Importing countries configuration
import { profile } from 'config/config'; // Importing profile configuration
import {
    devConfig, // Importing development configuration
    accountingAccounts, // Importing accounting accounts configuration
    providersSMS, // Importing SMS providers configuration
    providersEmail, // Importing email providers configuration
    providerPaymentWithdrawal, // Importing payment withdrawal provider configuration
} from 'config/config'; // Importing various configurations from config

/**
 * Class representing the SEO settings view.
 * @extends JetView
 */
export default class SettingSEOView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        var partnerCountry; // Variable to hold partner country data
        const vthis = this; // Reference to the current instance
        var seo = []; // Array to hold SEO data
        var pageAddQuetion = ''; // Variable to hold the page question to add
        var keyAddQuetion = ''; // Variable to hold the key of the question to add
        var actives = []; // Array to hold active elements

        // Event listener for partner settings filter
        this.on(this.app, 'partnerSettings:filter', (filterdata) => {
            partnerCountry = filterdata; // Set partner country from filter data
            webix
                .ajax() // AJAX request to fetch partner settings SEO
                .headers({
                    'Content-type': 'application/json', // Set content type to JSON
                })
                .post(
                    devConfig.geturlApi() + 'es/Setting/GetPartnerSettingsSEO', // API endpoint
                    filterdata, // Data to send
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error callback
                            webix.message('Error! '); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success callback
                            var resp = JSON.parse(text); // Parse response
                            if (!resp.HasError) {
                                // Check for errors in response
                                if (resp.Data != null && resp.Data != undefined && resp.Data != '') {
                                    seo = resp.Data.seo; // Set SEO data from response
                                    vthis.app.callEvent('setSEO', [seo]); // Trigger setSEO event
                                } else {
                                    seo = []; // Reset SEO data if empty
                                }
                                vthis.app.callEvent('resizeb1'); // Trigger resize event
                            } else {
                                webix.message({
                                    // Show error message if response has error
                                    title: _('¡Error!'),
                                    type: 'alert-error',
                                    text: _('Ocurrio un error, comuniquese con soporte'),
                                });
                                $$('addSEO').hide(); // Hide add SEO button
                            }
                        },
                    },
                );
        });

        // Event listener for resizing the view
        this.on(this.app, 'resizeb1', function () {
            $$('dataview').clearAll(); // Clear data view
            $$('dataview').parse(seo); // Parse SEO data into data view
            $$('dataview1').show(); // Show data view
            $$('addSEO').show(); // Show add SEO button
            var acc = document.getElementsByClassName('seo_title'); // Get all SEO title elements
            for (var i = 0; i < acc.length; i++) {
                // Add click event to each title
                acc[i].addEventListener('click', function () {
                    this.classList.toggle('active'); // Toggle active class
                    var panel = this.nextElementSibling; // Get the next sibling panel
                    if (panel.style.display === 'block') {
                        panel.style.display = 'none'; // Hide panel if visible
                    } else {
                        panel.style.display = 'block'; // Show panel if hidden
                    }
                });
            }
            var accQuestions = document.getElementsByClassName(
                'seo_title_questions', // Get all SEO title questions
            );
            for (var o = 0; o < accQuestions.length; o++) {
                // Add click event to each question title
                accQuestions[o].addEventListener('click', function () {
                    this.classList.toggle('active'); // Toggle active class
                    var panel = this.nextElementSibling; // Get the next sibling panel
                    if (panel.style.display === 'block') {
                        panel.style.display = 'none'; // Hide panel if visible
                    } else {
                        panel.style.display = 'block'; // Show panel if hidden
                    }
                });
            }
            seo.forEach(function (element, key) {
                // Iterate over SEO data
                var namesArray = Object.getOwnPropertyNames(
                    Object.values(element)[0], // Get property names of the first element
                );
                namesArray.forEach(function (element2, key2) {
                    // Iterate over property names
                    if (element2 == 'P') {
                        // Check if property is 'P'
                        var str = '#'; // Selector string
                        var editor = CKEDITOR.replace(
                            // Initialize CKEditor
                            document.querySelector(
                                str +
                                    Object.keys(element)[0]
                                        .toString()
                                        .replace(/[/]/g, '')
                                        .replace(/[:]/g, '')
                                        .replace(/[.]/g, '')
                                        .replace(/[ ]/g, '')
                                        .replace(/[%]/g, '')
                                        .replace(/[¿]/g, '')
                                        .replace(/[?]/g, '') +
                                    '-' +
                                    element2,
                            ),
                            {
                                versionCheck: false, // Disable version check
                            },
                        );
                        editor.on('change', function (evt) {
                            // Change event for CKEditor
                            seo[key][Object.getOwnPropertyNames(element)[0]][element2] = evt.editor.getData(); // Update SEO data on change
                        });
                    }
                });
                document.getElementById(
                    'delete-' +
                        Object.keys(element)[0]
                            .replace(/[/]/g, '')
                            .replace(/[:]/g, '')
                            .replace(/[.]/g, '')
                            .replace(/[ ]/g, '')
                            .replace(/[%]/g, '')
                            .replace(/[¿]/g, '')
                            .replace(/[?]/g, ''),
                ).onclick = function () {
                    // Delete button click event
                    seo.splice(key, 1); // Remove SEO entry
                    vthis.app.callEvent('resizeb1'); // Trigger resize event
                    seo.forEach(function (element, key) {
                        // Update delete buttons for remaining entries
                        document.getElementById(
                            'delete-' +
                                Object.keys(element)[0]
                                    .replace(/[/]/g, '')
                                    .replace(/[:]/g, '')
                                    .replace(/[.]/g, '')
                                    .replace(/[ ]/g, '')
                                    .replace(/[%]/g, '')
                                    .replace(/[¿]/g, '')
                                    .replace(/[?]/g, ''),
                        ).onclick = function () {
                            seo.splice(key, 1); // Remove SEO entry
                            vthis.app.callEvent('resizeb1'); // Trigger resize event
                        };
                    });
                };
                document.getElementById('addQuestions-' + Object.keys(element)[0]).onclick = function () {
                    // Add questions button click event
                    for (var u = 0; u < acc.length; u++) {
                        // Check active titles
                        if (acc[u].className == 'seo_title active') {
                            actives.push(u); // Store active indices
                        }
                    }
                    pageAddQuetion = Object.keys(element)[0]; // Set page question
                    keyAddQuetion = key; // Set key for question
                    $$('addformQuestion').clearValidation(); // Clear validation
                    $$('AddQuestion').show(); // Show add question form
                };
                var questionsArray = seo[key][Object.getOwnPropertyNames(element)[0]]['QUESTIONS']; // Get questions array
                questionsArray.forEach(function (elementQuestionsArray, keyQuestionsArray) {
                    // Iterate over questions
                    document.getElementById(
                        'deleteQuestions-' +
                            keyQuestionsArray +
                            '-' +
                            Object.keys(element)[0]
                                .toString()
                                .replace(/[/]/g, '')
                                .replace(/[:]/g, '')
                                .replace(/[.]/g, '')
                                .replace(/[ ]/g, '')
                                .replace(/[%]/g, ''),
                    ).onclick = function () {
                        // Delete question button click event
                        seo[key][Object.keys(element)[0]]['QUESTIONS'].splice(keyQuestionsArray, 1); // Remove question
                        for (var u = 0; u < acc.length; u++) {
                            // Update active titles
                            if (acc[u].className == 'seo_title active') {
                                actives.push(u);
                            }
                        }
                        vthis.app.callEvent('resizeb1'); // Trigger resize event
                        seo.forEach(function (element, key) {
                            // Update delete buttons for remaining questions
                            var questionsArray = seo[key][Object.getOwnPropertyNames(element)[0]]['QUESTIONS'];
                            questionsArray.forEach(function (elementQuestionsArray, keyQuestionsArray) {
                                document.getElementById(
                                    'deleteQuestions-' +
                                        keyQuestionsArray +
                                        '-' +
                                        Object.keys(element)[0]
                                            .toString()
                                            .replace(/[/]/g, '')
                                            .replace(/[:]/g, '')
                                            .replace(/[.]/g, '')
                                            .replace(/[ ]/g, '')
                                            .replace(/[%]/g, ''),
                                ).onclick = function () {
                                    seo[key][Object.keys(element)[0]]['QUESTIONS'].splice(keyQuestionsArray, 1); // Remove question
                                    for (var u = 0; u < acc.length; u++) {
                                        if (acc[u].className == 'seo_title active') {
                                            actives.push(u);
                                        }
                                    }
                                    vthis.app.callEvent('resizeb1'); // Trigger resize event
                                };
                            });
                        });
                    };
                });
            });
            for (var j = 0; j < actives.length; j++) {
                // Show active panels
                acc[actives[j]].classList.toggle('active'); // Toggle active class
                acc[actives[j]].nextElementSibling.style.display = 'block'; // Show panel
            }
            actives = []; // Reset active array
        });

        // Event listener for adding SEO data
        this.on(this.app, 'addSEO', (data) => {
            seo.forEach(function (element, key) {
                // Iterate over SEO data
                var namesArray = Object.getOwnPropertyNames(
                    Object.values(element)[0], // Get property names of the first element
                );
                namesArray.forEach(function (element2, key2) {
                    // Iterate over property names
                    if (element2 != 'P') {
                        // Check if property is not 'P'
                        if (element2 == 'QUESTIONS') {
                            // Check if property is 'QUESTIONS'
                            var questionsArray = seo[key][Object.getOwnPropertyNames(element)[0]]['QUESTIONS']; // Get questions array
                            questionsArray.forEach(function (elementQuestionsArray, keyQuestionsArray) {
                                seo[key][Object.getOwnPropertyNames(element)[0]]['QUESTIONS'][keyQuestionsArray] = {
                                    QUESTION: document.getElementById(
                                        keyQuestionsArray +
                                            '-0-' +
                                            Object.keys(element)[0]
                                                .toString()
                                                .replace(/[/]/g, '')
                                                .replace(/[:]/g, '')
                                                .replace(/[.]/g, '')
                                                .replace(/[ ]/g, '')
                                                .replace(/[%]/g, ''),
                                    ).value,
                                    RESPONSE: document.getElementById(
                                        keyQuestionsArray +
                                            '-1-' +
                                            Object.keys(element)[0]
                                                .toString()
                                                .replace(/[/]/g, '')
                                                .replace(/[:]/g, '')
                                                .replace(/[.]/g, '')
                                                .replace(/[ ]/g, '')
                                                .replace(/[%]/g, ''),
                                    ).value,
                                }; // Update question and response
                            });
                        } else {
                            seo[key][Object.getOwnPropertyNames(element)[0]][element2] = document.getElementById(
                                Object.keys(element)[0]
                                    .toString()
                                    .replace(/[/]/g, '')
                                    .replace(/[:]/g, '')
                                    .replace(/[.]/g, '')
                                    .replace(/[ ]/g, '')
                                    .replace(/[%]/g, '') +
                                    '-' +
                                    element2,
                            ).value; // Update other properties
                        }
                    }
                });
            });
            if (data.length > 0) {
                // Check if there is new data to add
                data.forEach(function (element, key) {
                    seo.push(element); // Add new SEO data
                });
            }
            vthis.app.callEvent('resizeb1'); // Trigger resize event
        });

        // Event listener for adding a question
        this.on(this.app, 'addQuestion', (data) => {
            seo.forEach(function (element, key) {
                // Iterate over SEO data
                var namesArray = Object.getOwnPropertyNames(
                    Object.values(element)[0], // Get property names of the first element
                );
                namesArray.forEach(function (element2, key2) {
                    // Iterate over property names
                    if (element2 != 'P') {
                        // Check if property is not 'P'
                        if (element2 == 'QUESTIONS') {
                            // Check if property is 'QUESTIONS'
                            var questionsArray = seo[key][Object.getOwnPropertyNames(element)[0]]['QUESTIONS']; // Get questions array
                            questionsArray.forEach(function (elementQuestionsArray, keyQuestionsArray) {
                                seo[key][Object.getOwnPropertyNames(element)[0]]['QUESTIONS'][keyQuestionsArray] = {
                                    QUESTION: document.getElementById(
                                        keyQuestionsArray +
                                            '-0-' +
                                            Object.keys(element)[0]
                                                .toString()
                                                .replace(/[/]/g, '')
                                                .replace(/[:]/g, '')
                                                .replace(/[.]/g, '')
                                                .replace(/[ ]/g, '')
                                                .replace(/[%]/g, ''),
                                    ).value,
                                    RESPONSE: document.getElementById(
                                        keyQuestionsArray +
                                            '-1-' +
                                            Object.keys(element)[0]
                                                .toString()
                                                .replace(/[/]/g, '')
                                                .replace(/[:]/g, '')
                                                .replace(/[.]/g, '')
                                                .replace(/[ ]/g, '')
                                                .replace(/[%]/g, ''),
                                    ).value,
                                }; // Update question and response
                            });
                        } else {
                            seo[key][Object.getOwnPropertyNames(element)[0]][element2] = document.getElementById(
                                Object.keys(element)[0]
                                    .toString()
                                    .replace(/[/]/g, '')
                                    .replace(/[:]/g, '')
                                    .replace(/[.]/g, '')
                                    .replace(/[ ]/g, '')
                                    .replace(/[%]/g, '') +
                                    '-' +
                                    element2,
                            ).value; // Update other properties
                        }
                    }
                });
            });
            seo[keyAddQuetion][pageAddQuetion]['QUESTIONS'].push({
                // Add new question
                QUESTION: data.QUESTION,
                RESPONSE: '',
            });
            vthis.app.callEvent('resizeb1'); // Trigger resize event
        });

        // Return the configuration for the view
        return {
            id: 'dataview1', // ID for the main data view
            rows: [
                {
                    view: 'dataview', // Data view for displaying SEO data
                    css: 'seo_dataview1', // CSS class for styling
                    id: 'dataview', // ID for the data view
                    template: function (obj) {
                        // Template function for rendering each item
                        delete obj['id']; // Remove ID from object
                        var template = ``; // Initialize template string
                        var namesArray = Object.getOwnPropertyNames(
                            Object.values(obj)[0], // Get property names of the first element
                        );
                        var valuesArray = Object.values(Object.values(obj)[0]); // Get values of the first element
                        namesArray.forEach(function (element, key) {
                            // Iterate over property names
                            if (element == 'QUESTIONS') {
                                // Check if property is 'QUESTIONS'
                                var arrayQuestions = Object.values(obj)[0]['QUESTIONS']; // Get questions array
                                var templateQuestions = ``; // Initialize questions template
                                arrayQuestions.forEach(function (elementQuestion, keyQuestion) {
                                    // Iterate over questions
                                    var templateInside = ``; // Initialize inside template
                                    var valuesArrayQuestions = Object.values(arrayQuestions[keyQuestion]); // Get values of the question
                                    var question = ''; // Variable to hold question text
                                    valuesArrayQuestions.forEach(function (elementQuestion2, keyQuestion2) {
                                        var label = ''; // Variable to hold label text
                                        if (keyQuestion2 == 0) {
                                            // Check if it's the question
                                            label = 'QUESTION'; // Set label to QUESTION
                                            question = elementQuestion2; // Set question text
                                        } else {
                                            if (keyQuestion2 == 1) {
                                                // Check if it's the response
                                                label = 'RESPONSE'; // Set label to RESPONSE
                                            }
                                        }
                                        templateInside =
                                            templateInside +
                                            `
                                <div>
                                  <label class="seo_label">
         											        ` +
                                            label +
                                            `
                                  </label><br>
								                  <textarea class="seo_input" style="width: 93%;" id="` +
                                            (keyQuestion + `-` + keyQuestion2 + `-` + Object.keys(obj))
                                                .toString()
                                                .replace(/[/]/g, '')
                                                .replace(/[:]/g, '')
                                                .replace(/[.]/g, '')
                                                .replace(/[ ]/g, '')
                                                .replace(/[%]/g, '') +
                                            `">` +
                                            elementQuestion2 +
                                            `</textarea>
                                </div>`; // Create textarea for question/response
                                    });
                                    var templateInside2 =
                                        `
                             <div id="seo_inside">
              									` +
                                        templateInside +
                                        `
              							 </div>`; // Wrap inside template
                                    templateQuestions =
                                        templateQuestions +
                                        `
                             <div class="seo_container">
              							  <div class="seo_item">
                                <div class="seo_title_questions">
                                  ` +
                                        question +
                                        `
                                  <div class="seo_delete">
                                    <span class='webix_icon wxi-close delete' id="deleteQuestions-` +
                                        (keyQuestion + `-` + Object.keys(obj))
                                            .toString()
                                            .replace(/[/]/g, '')
                                            .replace(/[:]/g, '')
                                            .replace(/[.]/g, '')
                                            .replace(/[ ]/g, '')
                                            .replace(/[%]/g, '') +
                                        `"></span>
                                  </div>
                                </div>
                                <div class="seo_body">
                                  <form name="valform" id="valform">` +
                                        templateInside2 +
                                        `
                                  </form>
                                </div>
                              </div>
                              </div>`; // Create container for question
                                });
                                template =
                                    template +
                                    `
            							<div>
            								<label class="seo_label" for="` +
                                    Object.keys(obj)
                                        .toString()
                                        .replace(/[/]/g, '')
                                        .replace(/[:]/g, '')
                                        .replace(/[.]/g, '')
                                        .replace(/[ ]/g, '')
                                        .replace(/[%]/g, '') +
                                    `-` +
                                    element +
                                    `">
            									` +
                                    element +
                                    `
            								</label>
            								<br>
            								<div class="seo_questions">
                              <a class='seo_button' id="addQuestions-` +
                                    Object.keys(obj) +
                                    `">Añadir</a><br>
              								` +
                                    templateQuestions +
                                    `
            								</div>
            							</div>`; // Create container for questions
                            } else {
                                template =
                                    template +
                                    `
                          <div>
                            <label class="seo_label" for="` +
                                    Object.keys(obj)
                                        .toString()
                                        .replace(/[/]/g, '')
                                        .replace(/[:]/g, '')
                                        .replace(/[.]/g, '')
                                        .replace(/[ ]/g, '')
                                        .replace(/[%]/g, '') +
                                    `-` +
                                    element +
                                    `">
                              ` +
                                    element +
                                    `
                            </label>
                            <br>
                            <textarea class="seo_input" id="` +
                                    Object.keys(obj)
                                        .toString()
                                        .replace(/[/]/g, '')
                                        .replace(/[:]/g, '')
                                        .replace(/[.]/g, '')
                                        .replace(/[ ]/g, '')
                                        .replace(/[%]/g, '') +
                                    `-` +
                                    element +
                                    `" name="` +
                                    Object.keys(obj)
                                        .toString()
                                        .replace(/[/]/g, '')
                                        .replace(/[:]/g, '')
                                        .replace(/[.]/g, '')
                                        .replace(/[ ]/g, '')
                                        .replace(/[%]/g, '') +
                                    `-` +
                                    element +
                                    `">` +
                                    valuesArray[key] +
                                    `</textarea>
                          </div>`; // Create textarea for other properties
                            }
                        });
                        var template2 =
                            `<div id="seo_panel">
                     ` +
                            template +
                            `
                    </div>`; // Wrap the main template
                        return (
                            `<div class="seo_container">
              							  <div class="seo_item">
                                <div class="seo_title">
                                  ` +
                            Object.keys(obj) +
                            `
                                  <div class="seo_delete">
                                    <span class='webix_icon wxi-close delete' id="delete-` +
                            Object.keys(obj)
                                .toString()
                                .replace(/[/]/g, '')
                                .replace(/[:]/g, '')
                                .replace(/[.]/g, '')
                                .replace(/[ ]/g, '')
                                .replace(/[%]/g, '')
                                .replace(/[¿]/g, '')
                                .replace(/[?]/g, '') +
                            `"></span>
                                  </div>
                                </div>
                                <div class="seo_body">
                                  <form name="valform" id="valform">` +
                            template2 +
                            `
                                  </form>
                                </div>
              							  </div>
              							</div>` // Create container for SEO item
                        );
                    },
                    scroll: screen == 'small' ? true : false, // Enable scrolling based on screen size
                    type: {
                        width: 'auto', // Set width to auto
                        height: 'auto', // Set height to auto
                        css: 'seo_dataview', // CSS class for styling
                    },
                },
                {
                    view: 'button', // Button for saving changes
                    value: _('Guardar'), // Button label
                    type: 'form', // Button type
                    minWidth: 200, // Minimum width for the button
                    click: () => {
                        // Click event for the button
                        webix.confirm({
                            // Confirmation dialog before saving
                            type: 'confirm-warning',
                            text:
                                _('Advertencia!') +
                                '<br/>' +
                                _('¿Esta seguro de realizar cambios en la configuración del SEO?'),
                            ok: _('Guardar'), // Confirm button label
                            cancel: _('Salir'), // Cancel button label
                            callback: function (action) {
                                // Callback for confirmation
                                if (action === true) {
                                    // If confirmed
                                    seo.forEach(function (element, key) {
                                        // Iterate over SEO data
                                        var namesArray = Object.getOwnPropertyNames(Object.values(element)[0]); // Get property names
                                        namesArray.forEach(function (element2, key2) {
                                            // Iterate over property names
                                            if (element2 != 'P') {
                                                // Check if property is not 'P'
                                                if (element2 == 'QUESTIONS') {
                                                    // Check if property is 'QUESTIONS'
                                                    var questionsArray =
                                                        seo[key][Object.getOwnPropertyNames(element)[0]]['QUESTIONS']; // Get questions array
                                                    questionsArray.forEach(
                                                        function (elementQuestionsArray, keyQuestionsArray) {
                                                            seo[key][Object.getOwnPropertyNames(element)[0]][
                                                                'QUESTIONS'
                                                            ][keyQuestionsArray] = {
                                                                QUESTION: document.getElementById(
                                                                    keyQuestionsArray +
                                                                        '-0-' +
                                                                        Object.keys(element)[0]
                                                                            .toString()
                                                                            .replace(/[/]/g, '')
                                                                            .replace(/[:]/g, '')
                                                                            .replace(/[.]/g, '')
                                                                            .replace(/[ ]/g, '')
                                                                            .replace(/[%]/g, ''),
                                                                ).value,
                                                                RESPONSE: document.getElementById(
                                                                    keyQuestionsArray +
                                                                        '-1-' +
                                                                        Object.keys(element)[0]
                                                                            .toString()
                                                                            .replace(/[/]/g, '')
                                                                            .replace(/[:]/g, '')
                                                                            .replace(/[.]/g, '')
                                                                            .replace(/[ ]/g, '')
                                                                            .replace(/[%]/g, ''),
                                                                ).value,
                                                            }; // Update question and response
                                                        },
                                                    );
                                                } else {
                                                    seo[key][Object.getOwnPropertyNames(element)[0]][element2] =
                                                        document.getElementById(
                                                            Object.keys(element)[0]
                                                                .toString()
                                                                .replace(/[/]/g, '')
                                                                .replace(/[:]/g, '')
                                                                .replace(/[.]/g, '')
                                                                .replace(/[ ]/g, '')
                                                                .replace(/[%]/g, '') +
                                                                '-' +
                                                                element2,
                                                        ).value; // Update other properties
                                                }
                                            }
                                        });
                                    });
                                    var params = {
                                        // Parameters for the API request
                                        Partner: partnerCountry.Partner,
                                        Country: partnerCountry.Country,
                                        Language: partnerCountry.Language,
                                        Data: {
                                            seo: seo, // SEO data to send
                                        },
                                    };
                                    console.log(params); // Log parameters for debugging
                                    webix
                                        .ajax() // AJAX request to update SEO settings
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Setting/UpdatePartnerSettingsSEO', // API endpoint
                                            JSON.stringify(params), // Send parameters as JSON
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error callback
                                                    webix.message({
                                                        // Show error message
                                                        title: _('¡Error!'),
                                                        type: 'alert-error',
                                                        text: _('Ocurrio un error, comuniquese con soporte'),
                                                    });
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success callback
                                                    var resp = JSON.parse(text); // Parse response
                                                    if (!resp.HasError) {
                                                        // Check for errors in response
                                                        webix.message({
                                                            // Show success message
                                                            text: _('Informacíon Actualizada'),
                                                            title: _('¡Exito!'),
                                                            type: 'alert-warning',
                                                        });
                                                        $$('dataview1').hide(); // Hide data view
                                                        $$('addSEO').hide(); // Hide add SEO button
                                                        $$('b1').collapse(); // Collapse button
                                                        $$('Countries').define('value', 'null'); // Reset countries dropdown
                                                        $$('Countries').refresh(); // Refresh countries dropdown
                                                        $$('Language').define('value', 'null'); // Reset language dropdown
                                                        $$('Language').refresh(); // Refresh language dropdown
                                                    } else {
                                                        webix.message({
                                                            // Show error message if response has error
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _('Ocurrio un error, comuniquese con soporte'),
                                                        });
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        });
                    },
                },
            ],
        };
    }

    /**
     * Initializes the view.
     * @param {Object} form - The form object.
     */
    init(form) {
        $$('dataview1').hide(); // Hide data view initially
        $$('addSEO').hide(); // Hide add SEO button initially
        const _ = this.app.getService('locale')._; // Localization service
        const vthis = this; // Reference to the current instance
        var getSeo = []; // Array to hold fetched SEO data
        this.on(this.app, 'setSEO', (data) => {
            getSeo = data; // Set fetched SEO data
        });
        var popupAdd = webix.ui({
            // Popup for adding SEO
            view: 'window',
            id: 'AddSEO',
            width: screen.width < 500 ? 350 : 450, // Set width based on screen size
            height: screen.width < 500 ? 250 : 150, // Set height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir SEO') }, // Label for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Modal popup
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y',
                body: {
                    view: 'form', // Form for adding SEO
                    id: 'addform',
                    width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                    height: screen.width < 500 ? 250 : 100, // Set height based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for page title
                            label: _('PÁGINA:'),
                            name: 'TITLE',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide popup on cancel
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        // Click event for save button
                                        var values = $$('addform').getValues(); // Get form values
                                        if ($$('addform').validate()) {
                                            // Validate form
                                            var flag = true; // Flag for checking duplicates
                                            getSeo.forEach(function (element, key) {
                                                // Check for existing titles
                                                if (Object.keys(element)[0].toString() === values.TITLE) {
                                                    webix.message({
                                                        // Show error message if title exists
                                                        title: _('¡Error!'),
                                                        type: 'alert-error',
                                                        text: _('Página ya existe'),
                                                    });
                                                    flag = false; // Set flag to false
                                                }
                                            });
                                            if (flag) {
                                                // If no duplicates
                                                var internalObj = {}; // Internal object for new SEO entry
                                                internalObj.HEAD_TITLE = '';
                                                internalObj.HEAD_DESCRIPTION = '';
                                                internalObj.HEAD_KEYWORDS = '';
                                                internalObj.H1 = '';
                                                internalObj.H2 = '';
                                                internalObj.H3 = '';
                                                internalObj.P = '';
                                                internalObj.CANONICAL = '';
                                                internalObj.SCHEMA = '';
                                                internalObj.QUESTIONS = []; // Initialize questions array
                                                var object = {}; // Create object for new entry
                                                object[values.TITLE] = internalObj; // Set title as key
                                                var array = []; // Array to hold new entry
                                                array.push(object); // Add object to array
                                                vthis.app.callEvent('addSEO', [array]); // Trigger addSEO event
                                                $$('addform').setValues(
                                                    $$('addform').getCleanValues(), // Reset form values
                                                );
                                                this.getTopParentView().hide(); // Hide popup
                                            }
                                        } else {
                                            webix.message({
                                                // Show error message if validation fails
                                                title: _('¡Error!'),
                                                type: 'alert-error',
                                                text: _('Completa los campos...'),
                                            });
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                    elementsConfig: {
                        on: {
                            onChange: function () {
                                this.validate(); // Validate on change
                            },
                        },
                    },
                },
            },
        });
        var popupAddQuestion = webix.ui({
            // Popup for adding questions
            view: 'window',
            id: 'AddQuestion',
            width: screen.width < 500 ? 350 : 450, // Set width based on screen size
            height: screen.width < 500 ? 250 : 150, // Set height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Pregunta') }, // Label for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Modal popup
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y',
                body: {
                    view: 'form', // Form for adding question
                    id: 'addformQuestion',
                    width: screen.width < 500 ? 350 : 450, // Set width based on screen size
                    height: screen.width < 500 ? 250 : 100, // Set height based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for question
                            label: _('PREGUNTA:'),
                            name: 'QUESTION',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide popup on cancel
                                        $$('addformQuestion').setValues(
                                            $$('addformQuestion').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        // Click event for save button
                                        var values = $$('addformQuestion').getValues(); // Get form values
                                        if ($$('addformQuestion').validate()) {
                                            // Validate form
                                            vthis.app.callEvent('addQuestion', [
                                                values, // Trigger addQuestion event
                                            ]);
                                            $$('addformQuestion').setValues(
                                                $$('addformQuestion').getCleanValues(), // Reset form values
                                            );
                                            this.getTopParentView().hide(); // Hide popup
                                        } else {
                                            webix.message({
                                                // Show error message if validation fails
                                                title: _('¡Error!'),
                                                type: 'alert-error',
                                                text: _('Completa los campos...'),
                                            });
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                    elementsConfig: {
                        on: {
                            onChange: function () {
                                this.validate(); // Validate on change
                            },
                        },
                    },
                },
            },
        });
    }
}

// FILE DOCUMENTED
